export default {
  name: 'KControlGroup',
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  render() {
    const data = {
      class: {
        'km-control-group--vertical': this.vertical,
      },
    }

    return (
      <div class="km-control-group" {...data}>
        {this.$slots.default}
      </div>
    )
  },
  methods: {},
}
